import roles from "@/roles";
export default [
  {
    icon: "view_day",
    title: "Packages",
    roles: [roles.ADMIN, roles.CALAMITY_ADMIN],
    children: [
      {
        icon: "map",
        router: true,
        title: "Current Overview Map",
        to: "CurrentOverviewMap",
        roles: [roles.ADMIN, roles.CALAMITY_ADMIN]
      }
      /*
      {
        icon: "settings",
        router: true,
        title: "Filter Config",
        to: "FilterConfig",
        roles: [roles.ADMIN, roles.BETA_FEATURE]
      }
      */
    ]
  }
];
